export enum WeixinEnum {
  WeixinLogin = "WeixinLogin",
  WeixinRegister = "WeixinRegister",
}

export const weixinTextEnum: Record<WeixinEnum, string> = {
  [WeixinEnum.WeixinLogin]: "登录",
  [WeixinEnum.WeixinRegister]: "注册",
};

export const useTabs = () => {
  const tabs = [
    {
      name: "登录",
      value: WeixinEnum.WeixinLogin,
    },
    {
      name: "注册",
      value: WeixinEnum.WeixinRegister,
    },
  ];

  return {
    tabs,
  };
};
